import NavbarComponent from "@/components/Navbar"
import GeneralLayout from "./General"


const PorcelainCatalogLayout = ({ children }) => {
  return (
    <>
      <GeneralLayout bgColor="bg-white" contentColor="text-charcoal-black" heroTitle="The Loro Blonyo" pageTitle="Fine Porcelain Collection">
        {children}
      </GeneralLayout>
    </>
  )
}

export default PorcelainCatalogLayout